import React from 'react';
import { DividendHistroyData } from '../../../types/dividendhistory.type';
import { formatDetailDate } from '../../../helpers/date';
import { formatLocaleNumber } from '../../../helpers/number';

interface DividendOverviewProps {
  data: DividendHistroyData;
}

const RatioCard = ({
  label,
  value,
  suffix,
}: {
  label: string;
  value: React.ReactNode;
  suffix?: string;
}) => (
  <div className="dh-ratio-card">
    <div className="dh-ratio-label">{label}</div>
    <div className="dh-ratio-value-row">
      <span className="dh-ratio-value">{value}</span>
      {value !== '-' && suffix && (
        <span className="dh-ratio-suffix">{suffix}</span>
      )}
    </div>
  </div>
);

const DividendOverview: React.FC<DividendOverviewProps> = ({ data }) => {
  if (!data?.ratio) return null;
  const { ratio } = data;

  const isPastDate = (dateStr?: string): boolean => {
    if (!dateStr) return false;
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date.getTime() < today.getTime();
  };

  const exDateLabel = isPastDate(ratio.DIVNQXDT)
    ? 'Latest ex-date'
    : 'Next ex-date';
  const payDateLabel = isPastDate(ratio.DIVNQPDT)
    ? 'Latest pay date'
    : 'Next pay date';

  return (
    <div className="dh-ratios-grid">
      <RatioCard
        label={exDateLabel}
        value={formatDetailDate(ratio.DIVNQXDT, false, 'YMD')}
      />
      <RatioCard
        label={payDateLabel}
        value={formatDetailDate(ratio.DIVNQPDT, false, 'YMD')}
      />
      <RatioCard
        label="Dividend (TTM)"
        value={formatLocaleNumber(ratio.TTMDIVSHR, 2)}
        suffix={ratio.div_currency}
      />
      <RatioCard
        label="Dividend yield (TTM)"
        value={formatLocaleNumber(ratio.DivYield_CurTTM, 2)}
        suffix="%"
      />
    </div>
  );
};

export default DividendOverview;
